module.exports = __webpack_public_path__ + "static/media/hall-CSS.744fd9ab.svg";